import { motion } from "motion/react";
import { Dialog as RDialog } from "radix-ui";

import { cn } from "shared/utils/cn";

export const Dialog = (props: RDialog.DialogProps) => {
  return <RDialog.Root {...props} />;
};

const Content = ({
  className,
  style,
  children,
  ...props
}: RDialog.DialogContentProps) => {
  return (
    <RDialog.Portal>
      <RDialog.Overlay asChild>
        <motion.div
          animate={{ opacity: 1 }}
          className="fixed inset-0 z-0 z-10000 bg-black/70"
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        />
      </RDialog.Overlay>
      <RDialog.Content {...props} asChild>
        <motion.div
          animate={{ opacity: 1 }}
          className={cn(
            "fixed top-1/2 left-1/2 w-11/12 max-w-96 -translate-x-1/2 -translate-y-1/2",
            "focus:outline-hidden",
            "z-10001 flex flex-col",
            "border-dark-grey rounded-4xl border bg-[#151515]/80 p-6 backdrop-blur-md",
            className
          )}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
          style={style}
        >
          {children}
        </motion.div>
      </RDialog.Content>
    </RDialog.Portal>
  );
};

const Title = ({ className, ...props }: RDialog.DialogTitleProps) => {
  return (
    <RDialog.Title
      className={cn(
        "text-lg leading-5.5 tracking-[0.4px] text-white",
        className
      )}
      {...props}
    />
  );
};

const Description = ({
  className,
  ...props
}: RDialog.DialogDescriptionProps) => {
  return (
    <RDialog.Description
      className={cn(
        "mt-2 mb-4 leading-5.5 tracking-[0.4px] text-white",
        className
      )}
      {...props}
    />
  );
};

Dialog.Content = Content;
Dialog.Title = Title;
Dialog.Description = Description;
Dialog.Close = RDialog.Close;
